import React, { useState } from "react";
import { Link } from "react-router-dom";
import brandLogo from "../assets/eldycare-logo.jpg";
import "./Navbar.css";

const Navbar = ({ onGetApp, onServices, overHero }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  const handleGetApp = () => {
    closeMenu();
    onGetApp();
  };

  const handleServices = (event) => {
    event.preventDefault();
    closeMenu();
    if (onServices) {
      onServices();
    }
  };

  return (
    <nav className={`navbar ${overHero ? "navbar-on-hero" : ""}`}>
      <Link to="/" className="navbar-logo" onClick={closeMenu}>
        <img src={brandLogo} alt="EldyCare" className="navbar-logo-img" />
      </Link>

      <div className={`navbar-links ${menuOpen ? "mobile-open" : ""}`}>
        <a href="#home" onClick={closeMenu}>Home</a>
        <a href="#services" onClick={handleServices}>Services</a>
        <a href="#pricing" onClick={closeMenu}>Pricing</a>
        <a href="#coverage" onClick={closeMenu}>Coverage</a>
        <a href="#faq" onClick={closeMenu}>FAQ</a>
        <button className="navbar-notify mobile-only" type="button" onClick={handleGetApp}>
          Notify me
        </button>
        <button className="navbar-btn mobile-only" type="button" onClick={handleGetApp}>
          Get the app
        </button>
      </div>

      <div className="navbar-right">
        <button className="navbar-notify" type="button" onClick={handleGetApp}>
          Notify me
        </button>
        <button className="navbar-btn" type="button" onClick={handleGetApp}>
          Get the app
        </button>
      </div>

      <button
        className="menu-icon"
        type="button"
        aria-label={menuOpen ? "Close menu" : "Open menu"}
        onClick={() => setMenuOpen((open) => !open)}
      >
        {menuOpen ? "✕" : "☰"}
      </button>
    </nav>
  );
};

export default Navbar;
